/*
 *  -----------------------------------------------------------------------
 *    <copyright file="schedule-bar.interface.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { ISVTGroupedVersions } from '@components/admin/schedule-versions-grid/schedule-versions-grid.interface';
import { StudyFields } from '@queries/generated/fragments.generated';

export interface ScheduleBarProps {
    groupedVersions: ISVTGroupedVersions;
    openAddSchedules: () => void;
    openImportAndTRSetup: () => void;
    canEdit: boolean;
    study: StudyFields | null;
}

export enum SVTInfoMessageType {
    information = 'information',
    warning = 'warning',
}
